import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions, Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import {HttpManagerService}  from '../../api/httpmanager.service';


@Injectable()
export class ClientService {
    constructor(private httpmanagerService: HttpManagerService) {
    }
    allClient(): Promise<any> {
        return this.httpmanagerService.HttpGet('client', "").then(function (data) {

            return data.data;
        });
    }
    iClient(app,image,is_form_data): Promise<any> {
        return this.httpmanagerService.HttpPostImage('client', JSON.stringify(app),image,is_form_data, "").then(function (data) {
            return data;
        });
    }
    uClientindex(app): Promise<any> {
        return this.httpmanagerService.HttpPost('client/updateindex', JSON.stringify(app), "").then(function (data) {
            return data;
        });
    }
    uClient(id, data,image,is_form_data): Promise<any> {
        return this.httpmanagerService.HttpPutImage('client', JSON.stringify(data),image,is_form_data, id).then(function (data) {
            return data;
        });
    }
    /*uClient(id, data) {
        let hea = new Headers();
        let opt = new RequestOptions({headers: hea});
        return this.http.put(this.appUrl + 'client/' + id, data, opt).map(
            (res: Response) => res.json());
    }*/
    dClient(id): Promise<any>{
        return this.httpmanagerService.HttpDelete('client',id).then(data =>{
            return data;
        })
    }
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix Website/Website_Admin/src/api/client/client.service.ts